import React from 'react';
import { UtensilsCrossed, Coffee, Flame, Truck } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { foodImages } from '../data/mock';

const Dining = () => {
  const services = [
    {
      icon: UtensilsCrossed,
      title: 'Vlastní restaurace',
      description: 'Celodenní stravování - snídaně, obědy a večeře připravované čerstvě',
      color: 'emerald'
    },
    {
      icon: Coffee,
      title: 'Venkovní bar',
      description: 'Stylový kamenný bar s příjemným posezením pod širým nebem',
      color: 'amber'
    },
    {
      icon: Flame,
      title: 'Grilování',
      description: 'Specialita na grilování selat a jiných mas na přání hostů',
      color: 'orange'
    },
    {
      icon: Truck,
      title: 'Catering',
      description: 'Vlastní catering s možností dovozu - studené mísy, řízečky, uzeniny',
      color: 'blue'
    }
  ];

  return (
    <section id="dining" className="py-20 bg-gradient-to-b from-emerald-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Gastronomie & Catering
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Kemp Josef klade velký důraz na kvalitní jídlo a společenské akce. 
            Nabízíme kompletní stravovací služby od snídaně až po večeři.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {services.map((service, index) => (
            <Card
              key={index}
              className="group text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-emerald-200"
            >
              <CardContent className="p-6">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-emerald-600 transition-colors">
                  <service.icon className="w-8 h-8 text-emerald-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mb-12">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-8">
            Naše speciality
          </h3>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {foodImages.slice(0, 8).map((image, index) => (
              <div
                key={index}
                className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <img
                  src={image}
                  alt={`Jídlo ${index + 1}`}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>

        <Card className="bg-gradient-to-r from-emerald-600 to-emerald-700 border-0 shadow-2xl">
          <CardContent className="p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div className="text-white">
                <h3 className="text-3xl font-bold mb-4">
                  Specialita domu
                </h3>
                <p className="text-emerald-100 text-lg leading-relaxed mb-6">
                  Naše největší specialita je grilování celých selat a dalších mas připravených 
                  na přání. Ideální pro větší akce, svatby a oslavy.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                    <span className="text-emerald-50">Studené mísy na objednávku</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                    <span className="text-emerald-50">Čerstvě připravené řízečky</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                    <span className="text-emerald-50">Domácí uzeniny a speciality</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                    <span className="text-emerald-50">Možnost dovozu cateringu</span>
                  </li>
                </ul>
              </div>
              
              <div className="relative">
                <img
                  src="https://i.ibb.co/qLdQVTFR/IMG-20260408-WA0034.jpg"
                  alt="Grilování"
                  className="rounded-xl shadow-2xl w-full h-80 object-cover"
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default Dining;
